module.exports = __webpack_public_path__ + "static/img/20.0878f71c.jpeg";